// extracted by mini-css-extract-plugin
module.exports = {"root":"BlackList_root__v4MlT"};